import { createContext, useState, useContext } from "react"

export const JustificationPageContext   = createContext()
export const useJustificationPage       = () => useContext(JustificationPageContext)

export const JustificationPageProvider  = ({ children }) => {

    //filter options
    const [ comparisionTypes,            setComparisionTypes          ]   = useState([])
    const [ selectedComparisionTypeId,   setSelectedComparisionTypeId ]   = useState(null)
    const [ selectedComparisionDate,     setSelectedComparisionDate   ]   = useState(null)
    const [ updateFilter,                setUpdateFilter              ]   = useState(false)

    const handlerUpdateFilter = () => setUpdateFilter(!updateFilter)

    //selected items    
    const [ selectedComparisionId,   setSelectedComparisionId         ]   = useState(null)   
    const [ selectedJustificationId, setSelectedJustificationId       ]   = useState(null)

    //update tables
    const [updateJustificationTable, setUpdateJustificationTable]               = useState(false)  
    const [updateComparisionTable,  setUpdateComparisionTable    ]               = useState(false)
    
    //modals
    const [isJustificationFormOpen,         setJustificationFormOpen        ]   = useState(false)  
    const [isJustificationFileFormOpen,     setJustificationFileFormOpen    ]   = useState(false)
    const [isJustificationListModalOpen,    setJustificationListModalOpen   ]   = useState(false) 

    const [isJustificationFormEditMode,    setJustificationFormEditMode     ]   = useState(false)

    //tables Contents
    const [comparisionData,     setComparisionData  ]                           = useState(null)
    const [justificationList,   setJustificationList]                           = useState([])

    const [comparisionNumber, setComparisionNumber]                             = useState(null)
    const value = {
           
        //filter options
        comparisionTypes,           setComparisionTypes,
        selectedComparisionTypeId,  setSelectedComparisionTypeId,
        selectedComparisionDate,    setSelectedComparisionDate,
        updateFilter,               handlerUpdateFilter,

        isJustificationFileFormOpen,
        handerOpenJustificationFileForm:  () => setJustificationFileFormOpen(true),
        handerCloseJustificationFileForm: () => setJustificationFileFormOpen(false),

        isJustificationFormOpen,
        handerOpenJustificationForm:        ()      => setJustificationFormOpen(true),
        handerCloseJustificationForm:       ()      => setJustificationFormOpen(false),

        isJustificationListModalOpen, 
        handerOpenJustificationListModal:   ()      => setJustificationListModalOpen(true),
        handerCloseJustificationListModal:  ()      => setJustificationListModalOpen(false),

        isJustificationFormEditMode,
        handlerSetJustificationFormEditMode: (isEditMode) => setJustificationFormEditMode(isEditMode),
        
        selectedComparisionId, setSelectedComparisionId,

        selectedJustificationId, 
        handleSetSelectedJustificationId:     (id)    => setSelectedJustificationId(id),

        updateComparisionTable,
        handleUpadeComparisionTable:        ()      => setUpdateComparisionTable(!updateComparisionTable),

        updateJustificationTable, 
        handleUpdateJustificationTable:     ()      => setUpdateJustificationTable(!updateJustificationTable),

        comparisionData, 
        handleSetComparisionData:           (data)  => setComparisionData(data),

        justificationList,
        handleSetComparisionList:           (data)  => setJustificationList(data),

        comparisionNumber, 
        setComparisionNumber
    }
    
    return (
        <JustificationPageContext.Provider value={value}>
            {children}
        </JustificationPageContext.Provider>
    )
}

